import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopularDestinationsRepository } from '@/core/domain/popular-destinations/repositories/popular-destinations.repository';
import { GetPopularDestinationsUseCase } from '../../core/domain/popular-destinations/usecases/getPopularDestinations.usecase';
import { PopularDestinationsImplRepository } from './popular-destinations.impl.repository';

const GetPopularDestinationsUseCaseFactory = (
    popularDestinationsRepository: PopularDestinationsRepository,
) => new GetPopularDestinationsUseCase(popularDestinationsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetPopularDestinationsUseCase,
            useFactory: GetPopularDestinationsUseCaseFactory,
            deps: [PopularDestinationsRepository],
        },
        {
            provide: PopularDestinationsRepository,
            useClass: PopularDestinationsImplRepository,
        },
    ],
})
export class PopularDestinationsDataModule {}
